import React, { Fragment, useEffect, useRef, useState } from 'react';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter, commonActionHeader } from '../../constants/StyleConstants';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import { AddBox } from '@material-ui/icons';
import EmailNotificationGrid from './EmailNotificationGrid';
import CreateEmailNotificationDialog from './CreateEmailNotificationDialog';
import useEmailNotificationPresenter from './EmailNotificationPresenter';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';

const useStyles = makeStyles(theme => {
    return {
      ...commonFilter,
      ...commonActionHeader(theme),
    };
  });

  const Filters = ({ filtersProps }) => {
    const classes = useStyles();
    // const { isAdmin } = useContext(LoginContext);
    const {  email, setEmail, validateAndSearch, cleanFilters, selectedSupplier, setSelectedSupplier } = filtersProps;
  
    return (
      <div className={classes.filters}>
        <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />
        <TextField margin="dense" id="emailEmployee" style={{ width: 200 }} label="Correo" onChange={e => setEmail(e.target.value)} value={email} />
        
        <div className={classes.filtersActionButton}>
          <Button variant="outlined" color="primary" onClick={validateAndSearch}>
            Filtrar
          </Button>
          <Button variant="outlined" color="secondary" onClick={cleanFilters}>
            Limpiar
          </Button>
        </div>
      </div>
    );
  };

const EmailNotification = () => {
  const classes = useStyles();
  const tableRef = useRef();
  const [openEmployee, setOpenEmployee] = useState(false)
  const { firstLoad, rows, loading, gridFunctions, newEmail, setNewEmail, ...filtersProps } = useEmailNotificationPresenter(tableRef);
  const { reloadGrid } = gridFunctions.gridActions;


  return (
    <Fragment>

      <ViewPortGridWrapper>
        
      <Filters filtersProps={filtersProps} />
      <div className={classes.actionHeader}>

        <Button
          variant="contained"
          color="primary"
          className={classes.actionHeaderButton}
          startIcon={<AddBox />}
          style={{ marginLeft: '10px' }}
          onClick={() => setOpenEmployee(true)}>
          Agregar Email
        </Button>
        
      </div>
      <CreateEmailNotificationDialog open={openEmployee} setOpen={setOpenEmployee} reloadGrid={reloadGrid} />
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <EmailNotificationGrid data={rows} loading={loading} tableRef={tableRef} newEmail={newEmail} setNewEmail={setNewEmail} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
    
    </Fragment>
    
    
  );
};

export default EmailNotification;